export const SUPPORT_EMAIL = "support@loop.org.uk";
export const SUPPORT_EMAIL_RSVT = "rsvtsupport@loop.org.uk";
export const SUPPORT_PHONE_NUMBER = "01482 765208";
